import type { ReactNode } from 'react';
import { Logo } from '@/app/layout/AppShell';

/** Brand panel + form column shared by sign-in, sign-up and accept-invite. */
export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="grid min-h-dvh lg:grid-cols-2">
      <div className="brand-gradient relative hidden overflow-hidden lg:flex lg:flex-col lg:justify-between lg:p-12">
        <div className="absolute -top-24 -right-24 h-96 w-96 rounded-full bg-white/10 blur-2xl" aria-hidden />
        <span className="font-heading text-lg font-bold text-white">Kollabr Support</span>
        <div className="relative max-w-md text-white">
          <h2 className="text-3xl leading-tight font-extrabold text-white">
            AI-first support for your customers — chat and email in one place.
          </h2>
          <p className="mt-3 text-white/80">
            An AI agent answers the routine questions from your help center and your own systems, and hands
            the rest to your team with the full story.
          </p>
        </div>
        <span className="text-sm text-white/70">kollabr.in</span>
      </div>

      <div className="flex items-center justify-center px-4 py-12 sm:px-6">
        <div className="w-full max-w-sm">
          <div className="mb-8">
            <Logo />
            <h1 className="mt-6 text-2xl font-bold">{title}</h1>
            {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          </div>
          {children}
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
